/**
 * Permit Status API
 *
 * API client functions for fetching permit status options.
 *
 * Endpoint : GET /jobs/permit-status
 * Method   : GET
 * Backend  : apps/backend/src/domains/works-lite/jobs/permit-status/routes.ts
 */

import { apiClient } from '@/lib/api';
import type { PermitStatusItem } from '@skewb-works/contracts';

// Re-export the shared type so consumers don't need to import from contracts directly
export type { PermitStatusItem };

/**
 * Fetch active permit status options (ordered by sequence ascending).
 */
export async function getPermitStatusList(): Promise<PermitStatusItem[]> {
  return apiClient.get<PermitStatusItem[]>('/jobs/permit-status');
}
